const featuresConstant = [
    { id: 1, title: '一對一高強度專注力教學', description: '提供一對一有進度的主課程及客製加強班，可針對孩子學習需求做選修補強，如：兒童檢定課程、發音、文法。', src: require('../static/kidsnew/icon1.png') },
    { id: 2, title: '同步英美小學優質教材', description: '使用全球暢銷且同步英美小學的ESL兒童英語教材，搭配新課綱及檢定教材，紮實步驟穩定學習。完整學習規劃。', src: require('../static/kidsnew/icon2.png') },
]

export default ({ feature_image = feature_image, features_group_a = featuresConstant, features_group_b = featuresConstant, title = "Etalking 有我們的堅持，只給學員最好的" }) => (
    <article id="feature">
        <h1>{title}</h1>
        <div className="feature_container">
            <div className="feature_row">
                <div className="feature_col">
                    <img
                        className="feature_img"
                        src='../static/kidsnew/img9.jpg'
                    />
                </div>
                <div className="feature_col">
                    <ul>
                        { features_group_a.map((item) =>
                            (
                                <li key={item.id}>
                                    <div className="list-img">
                                        <img
                                            key={`img-${item.id}`}
                                            src={item.src}
                                            alt={item.title}
                                        />
                                    </div>
                                    <div className="list-content">
                                        <h3>{item.title}</h3>
                                        <p>{item.description}</p>
                                    </div>
                                </li>
                            ))
                        }
                    </ul>
                </div>
            </div>
            <div className="feature_row">
                <div className="feature_col">
                    <img
                        className="feature_img"
                        src='../static/kidsnew/img10.jpg'
                    />
                </div>
                <div className="feature_col">
                    <ul>
                        { features_group_b.map((item) =>
                            (
                                <li key={item.id}>
                                    <div className="list-img">
                                        <img
                                            key={`img-${item.id}`}
                                            src={item.src}
                                            alt={item.title}
                                        />
                                    </div>
                                    <div className="list-content">
                                        <h3>{item.title}</h3>
                                        <p>{item.description}</p>
                                    </div>
                                </li>
                            ))
                        }
                    </ul>
                </div>
            </div>
        </div>
        <style jsx>{`
      article {
        background-color: #f7f7f7;
        padding-bottom: 5%;
      }

      h1 {
        text-align: center;
        font-size: 2.5em;
        font-weight: bold;
        padding: 5% 0 2%;
        color: #393e46;
      }
      
      .feature_container {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }
      
      .feature_row {
        position: relative;
        float: left;
        width: 900px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
      }
      
      .feature_col {
        position: relative;
        float: left;
        width: 50%;
      }
      
      @media(max-width: 768px){
        .feature_row {
            flex-direction: column;
        }
      }
      
      .feature_img {
        width: 90%;
        margin-left: 5%;
        margin-bottom: 5%;
      }
      
      @media(max-width: 768px){
        .feature_img {
            width: 80%;
            margin-left: 10%;
            margin-bottom: 10%;
        }
      }

      ul {
        list-style: none;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
        margin: 50px 5%;
      }

      li {
        display: flex;
        flex-direction: row;
        align-self: flex-start;
        width: 30%;
        padding: 0.5em 0 3em;
        position: relative;
        float: left;
        width: 100%;
      }

      .list-img {
        width: 100px;
        height: 100px;
        border-radius: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      
      .list-img > img {
        width: 100px;
      }

      .list-content {
        margin-left: 2%;
        max-width: 80%;
      }

      .list-content h3 {
        margin: 0.5em 0;
        color: #393e46;
        font-size: 1.4em;
        font-weight: bold;
      }

      .list-content p {
        font-size: 1em;
        line-height: 1.4em;
        color: #474a56;
        margin: 0 5% 0 0;
      }

      @media(max-width: 768px){
        article {
          padding-bottom: 2em;
        }

        h1 {
          padding: 1em 1em 1em;
          font-size: 1.5em;
        }

        ul {
          margin: 1em 2em;
        }

        li {
          width: 100%;
          margin: 10px;
          padding: 0.5em 0 1em;
        }
      }
    `}</style>
    </article>
)
